var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hz-emotion"},_vm._l((_vm.list),function(item,index){return _c('button',[_c('img',{staticClass:"hz-static-emotion",attrs:{"src":_vm.faceUrl+index+'.png'},on:{"click":function($event){return _vm.emotionSelect(item,index)}}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }